import React, { useEffect } from "react";
import EngagementOverTimeChart from "./EngagementOverTimeChart";
import Loading from "../Loading/Loading";
import NoData from "../NoData/NoData";

function EngagementByLikeComment(props) {
    const { widgetType } = props;
    const chartName = widgetType || "engagement_over_time";
    const chartLoading = props.chartDataLoading?.[chartName];
    // const isNoData = Object.keys(props.chartData?.engagement_over_time?.lineChartData || {}).length === 0;
    const isNoData = props.pageStatus || props.chartData?.[chartName]?.nodata;
    // console.log(props.chartData);
    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);

    // if (!isNoData) return <div>lalalla</div>;

    return (
        <>
            {chartLoading && <Loading />}
            {!isNoData && !chartLoading && (
                <EngagementOverTimeChart
                    chartName={chartName}
                    isLKPage={props.isLKPage}
                    chartData={props.chartData?.[chartName]}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    graphType={props.graphType}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                    showAverage={props.showAverage}
                    GMTTimeZone={props.GMTTimeZone}
                />
            )}
            {isNoData && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}
export default EngagementByLikeComment;
